import * as yup from 'yup';
import type { BannerFormData } from '../components/CreateBannerModal/CreateBannerModal';

export const bannerFormSchema: yup.ObjectSchema<BannerFormData> = yup.object({
  title: yup.string().required('Название обязательно'),
  link: yup.string().optional(),
  image: yup.mixed<File | { id: number; url: string }>()
    .required('Изображение баннера обязательно')
    .test('is-valid', 'Изображение обязательно', value => {
      return value !== undefined && value !== null;
    }),
  storyImages: yup.array()
    .of(yup.mixed<File | { id: number; url: string }>().required())
    .optional(),
});